<script lang="ts">
import Vue from 'vue'
import {getRegions, getManager, updateManager, getOrganizationInfo} from "@/api/organizations/organizations";
import BaseTag from "@/views/organizations/managers/components/BaseTag.vue";
import FileInput from "./policyCancel/components/FileInput.vue";

export default Vue.extend({
    name: "ProfileBanker",
    components: {FileInput, BaseTag},
    data() {
        return {
            regions: [],
            loadRegions: false,
            loadCities: false,
            citiesList: [],
            form: {
                lastName: null,
                firstName: null,
                middleName: null,
                uin: null,
                birthDate: null,
                phone: null,
                email: null,
                organizationId: null,
                regionId: null,
                branchId: null,
                cityId: null,
                street: null,
                house: null,
                apartment: null,
                certificate: null,
                certificateFile: null,
            },
            // organization: null,
            // region: null,
            // branch: null,
            errors: {},
        };
    },
    computed: {
        branches() {
            let region = this.regions.find(item => item.id === this.form.regionId)

            return region ? region.children : [];
        },
    },
    methods: {
        clearError(field) {
            if (this.errors && this.errors[field]) {
                this.$delete(this.errors, field);
            }
        },
        fetchCities(query) {
            this.loadCities = true;
            axios.get('/api/directories/cities/find?city=' + query).then(({data}) => {
                this.citiesList = data.data;
                this.loadCities = false;
            }).catch(err => (console.log(err)));
        },
        fetchCityById(id) {
            this.loadCities = true;
            axios.get('/api/directories/cities/get-by-id?id=' + id).then(({data}) => {
                this.citiesList = [data.data];
                this.loadCities = false;
            }).catch(err => (console.log(err)));
        },
        goBack() {
            this.$router.go(-1);
        },
        updateUser() {
            updateManager(this.form.id, this.form).then(response => {
                this.goBack()
            }).catch(err => {
                this.errors = err.response.data.data
            })
        },
        // getOrganizations() {
        //     getOrganizationInfo(this.$store.getters.USER_INFO.organizationId).then(response => {
        //         this.organization = response.data
        //     })
        //
        //     if (this.form.branchId) {
        //         getOrganizationInfo(this.form.branchId).then(response => {
        //             this.branch = response.data
        //         })
        //     }
        //
        //     if (this.form.regionId) {
        //         getOrganizationInfo(this.form.regionId).then(response => {
        //             this.region = response.data
        //         })
        //     }
        // }
    },
    created() {
        this.loadRegions = true;
        getRegions({organizationId: this.$store.getters.USER.organizationId}).then(response => {
            this.regions = response.data;
            this.loadRegions = false;
            getManager(this.$store.getters.USER.id).then(response => {
                this.form = response.data.data
                this.fetchCityById(this.form.cityId)
                // this.getOrganizations();
            })
        })
    },
})
</script>

<template>
<div class="create-edit-manager">
    <div class="manager-form m-4">
        <div class="manager-info">
            <div class="mb-4">Особисті дані:</div>
            <div class="row mb-4 form-group">
                <div class="col-4">
                    <label>Прізвище</label>
                    <input type="text"
                           :class="['form-control', errors['lastName'] ? 'is-invalid' : '']"
                            v-model="form.lastName"
                           @input="clearError('lastName')"
                    >
                    <div v-if="errors && errors['lastName']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['lastName'][0] }}
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <label>Імʼя</label>
                    <input  type="text"
                            :class="['form-control', errors['firstName'] ? 'is-invalid' : '']"
                            v-model="form.firstName"
                            @input="clearError('firstName')"
                    >
                    <div v-if="errors && errors['firstName']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['firstName'][0] }}
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <label>По батькові</label>
                    <input type="text"
                           :class="['form-control', errors['middleName'] ? 'is-invalid' : '']"
                           v-model="form.middleName"
                           @input="clearError('middleName')"
                    >
                    <div v-if="errors && errors['middleName']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['middleName'][0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4 form-group">
                <div class="col-6">
                    <label>ІПН</label>
                    <input type="text"
                            :class="['form-control', errors['middleName'] ? 'is-invalid' : '']"
                            v-model="form.uin"
                            v-mask="'##########'"
                    >
                </div>
                <div class="col-6">
                    <label>Дата народження</label>
                    <input type="text"
                           v-mask="'##.##.####'"
                           v-model.trim="form.birthDate"
                           :class="['form-control', errors['birthDate'] ? 'is-invalid' : '']"
                           @input="clearError('birthDate')"
                    >
                    <div v-if="errors && errors['birthDate']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['birthDate'][0] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="manager-info mt-4">
            <div class="mb-4">Контактна інформація:</div>
            <div class="row mb-4 form-group">
                <div class="col-6">
                    <label>Телефон</label>
                    <input type="text"
                           :class="['form-control', errors['phone'] ? 'is-invalid' : '']"
                           v-mask="'+38 (###) ###-##-##'"
                           v-model.trim="form.phone"
                           @input="clearError('phone')"
                    >
                    <div v-if="errors && errors['phone']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['phone'][0] }}
                        </div>
                    </div>
                </div>
                <div class="col-6 ">
                    <label>Email</label>
                    <input type="email"
                           :class="['form-control', errors['email'] ? 'is-invalid' : '']"
                           v-model="form.email"
                           @input="clearError('email')"
                    >
                    <div v-if="errors && errors['email']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['email'][0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4 form-group">
                <div class="col-4">
                    <label>Місто</label>
                    <el-select v-model="form.cityId"
                               placeholder="Місто"
                               remote
                               filterable
                               reserve-keyword
                               :loading="loadCities"
                               :remote-method="fetchCities"
                               :class="[errors['cityId'] ? 'is-invalid' : '']"
                               @update="clearError('cityId')"
                    >
                        <el-option v-for="item in citiesList"
                                   :key="item.id"
                                   :label="item.name_full_name_ua"
                                   :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div v-if="errors && errors['cityId']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['cityId'][0] }}
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <label>Вулиця</label>
                    <input type="text"
                           :class="['form-control', errors['street'] ? 'is-invalid' : '']"
                           v-model="form.street"
                           @input="clearError('street')"
                    >
                    <div v-if="errors && errors['street']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['street'][0] }}
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <label>Будинок</label>
                    <input type="text"
                           :class="['form-control', errors['house'] ? 'is-invalid' : '']"
                           v-model="form.house"
                           @input="clearError('house')"
                    >
                    <div v-if="errors && errors['house']" class="col-12">
                        <div class="invalid-feedback d-block">
                            {{ errors['house'][0] }}
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <label>Квартира</label>
                    <input type="text" class="form-control" v-model="form.apartment">
                </div>
            </div>
            <div class="row mb-4 form-group d-flex align-items-end">
                <div class="col-6">
                    <label>Інформація про підтвердження необхідного рівня знань</label>
                    <input type="text"
                           :class="['form-control', errors['street'] ? 'is-invalid' : '']"
                           v-model="form.certificate"
                    >
                </div>
                <div class="col-6" v-if="form.id">
                    <file-input ref="file-input" v-model="form.certificateFile" :file-url="form.certificateFileUrl">
                        Прикріпити сертифікат
                        <template #file="{file}">
                            <div class="custom-file">
                                <a :href="file.url" target="_blank">{{ file.name }}</a>
                                <el-button
                                    size="mini"
                                    type="text"
                                    icon="el-icon-delete"
                                    @click.prevent="$refs['file-input'].removeFile(); form.certificateFileUrl = null"
                                ></el-button>
                            </div>
                        </template>
                    </file-input>
                </div>
            </div>
        </div>
        <div class="row mt-8">
            <div class="col-6">
                <button type="button" class="btn btn-primary w-100" @click="updateUser">Зберегти</button>
            </div>
            <div class="col-6">
                <button type="button" class="btn btn-light w-100" @click="goBack">Повернутися назад</button>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
.create-edit-manager {
    .manager-title {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px 10px;
        gap: 10px;

        background: #F6F6F9;
        /* Додати менеджера */

        font-family: Geist;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #09090B;
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    .manager-form {
        .manager-info {
            font-family: Geist;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
            /* identical to box height, or 175% */
            color: #09090B;
            /* Inside auto layout */
            flex: none;
            order: 0;
            align-self: stretch;
            flex-grow: 0;
            border-bottom: 1px solid #E4E4E4;
            label {
                /* Text-sm/Medium */
                font-family: Geist;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #09090B;
                /* Inside auto layout */
                flex: none;
                order: 0;
                flex-grow: 0;
            }

            .form-control {
                margin-bottom: unset;
            }
        }
    }
}
.mt-8 {
    margin-top: 2rem;
}

* >>> .el-select {
    display: unset;
    position: unset;
    .el-input.is-focus {
        border-color: #FFAD3D;
    }
    .el-input__inner:focus {
        border-color: #FFAD3D;
    }
}
</style>
